import DomElementsBase from "@grindex-common/abstracts/DomElementsBase.class";

const SELECTOR_IFRAME = ".iframe-wrapper iframe";

export default class IframeBlockDomElements extends DomElementsBase {
	constructor($module) {
		const selectors = [SELECTOR_IFRAME];

		super($module, selectors);
	}

	iframe() {
		return this.getElement(SELECTOR_IFRAME);
	}
}
